import React, { useState } from 'react';
import styles from '../index.module.css';
import { OrderType } from 'models/order.model';
import { ReactComponent as EmptyUserImage } from 'assets/icons/empty-profile-image.svg';
import { ReactComponent as StarFilled } from 'assets/icons/star-filled.svg';
import { ReactComponent as UnfilledStar } from 'assets/icons/star-unfilled.svg';
import { ReactComponent as Placeholder } from 'assets/icons/user-icon.svg';
import { getNameFromOrder, getUserName, isCSRole } from 'utils/functions';
import ReassignRiderModal from 'components/live-trip-cards/live-trip-modals/reassign-rider-modal';
import BlacklistRiderModal from 'components/blacklist-rider-modal';
import { getCokitchenTeam } from 'utils/role-config';
import NoRider from '../no-rider';
import CopyText from 'components/base/copy-text';
import moment from 'moment';
import { ENUM_COKITCHEN_TEAM } from '@cokitchen/cokitchen-auth';

const OrderDetailsRider = ({ order, isComplete }: { order: OrderType; isComplete?: boolean }) => {
  const isNotLogistics =
    getCokitchenTeam() === ENUM_COKITCHEN_TEAM.KITCHEN ||
    getCokitchenTeam() === ENUM_COKITCHEN_TEAM.CS;
  const [showModal, setShowModal] = useState(false);
  const [showBlacklistRiderModal, setShowBlacklistRiderModal] = useState(false);
  const [rider, setRider] = useState(order.rider);
  const riderRate = Number(order?.order_review?.rider_rate);
  const unfilledStars = 5 - riderRate;

  const orderDetails = order.order_details;

  return (
    <div className={`${styles['section']} text-gray-5`}>
      {rider ? (
        <div>
          <div className='flex justify-between'>
            <p className=' py-[18px] font-medium'>Rider Details</p>

            {!isComplete && !isCSRole() && (
              <button
                className='text-sm w-fit font-medium text-[#E60A2B]'
                onClick={() => setShowModal(true)}>
                Reassign rider
              </button>
            )}
          </div>
          <div className='w-full bg-[#e2e7ee] h-[0.7px]' />
          <div className='flex justify-between items-center'>
            <div className='py-3.5 pb-2 text-sm '>
              <p className='pt-[12px] pb-[8px]  text-[#595959] text-lg font-medium'>
                {orderDetails?.delivery_handled_by
                  ? orderDetails?.partner_rider_name
                  : getUserName(rider)}
              </p>
              <p className='pb-[8px] text-[#858585] '>{rider?.email}</p>
              {/* <p className='pb-[24px] text-[#858585] flex items-center gap-2'> */}
              <CopyText
                className='pb-[24px] text-[#858585]'
                text={
                  orderDetails?.delivery_handled_by
                    ? orderDetails?.partner_rider_phone_number
                    : rider?.phone_number
                }
              />
              {/* </p> */}
            </div>
            <EmptyUserImage />
          </div>
          {orderDetails?.partner_delivery_id && (
            <div className='flex justify-between gap-4 mb-4'>
              <span>Tracking number:</span>
              <span>{orderDetails?.partner_delivery_id}</span>
            </div>
          )}
          {!order?.order_review?.rider_rate ? (
            <div className='bg-[#F7F7F8] text-[#7A7A85] rounded pl-[16px] py-2 h-24 mb-8 w-full flex items-center'>
              No review yet
            </div>
          ) : (
            <div className='p-4 mb-8 text-xs bg-[#F7F7F8] rounded-[4px]'>
              <div className='flex gap-4'>
                {order?.user?.profile_image ? (
                  <img
                    src={order?.user?.profile_image}
                    alt='profile-img'
                    className='w-10 h-10 rounded-full '
                  />
                ) : (
                  <div className='w-10 h-10 rounded-full bg-[#ffffff] flex items-center justify-center'>
                    <Placeholder />
                  </div>
                )}
                <div className='flex gap-4'>
                  <div>
                    <p className='text-[#7A7A85] mb-2 font-medium'>{getNameFromOrder(order)}</p>
                    <div className='flex'>
                      {Array(riderRate)
                        .fill(1)
                        .map((_, index) => (
                          <StarFilled key={index} className='w-[14px] h-[13px]' />
                        ))}
                      {unfilledStars
                        ? Array(unfilledStars)
                            .fill(1)
                            .map((_, index) => <UnfilledStar key={index} />)
                        : null}
                    </div>
                  </div>
                  <h3 className='text-[#A6A6A6]'>
                    {moment(order?.order_review?.created_at).format('Do MMM, YYYY')}
                  </h3>
                </div>
              </div>
              <p className='my-2'>
                {order?.order_review?.comment ? order?.order_review?.comment : 'No comment '}
              </p>
            </div>
          )}
          {isNotLogistics ? null : (
            <button
              onClick={() => setShowBlacklistRiderModal(true)}
              className={`border border-[#E3E6E8] text-center  w-full rounded-[4px] py-3 text-gray-6 font-medium text-sm mb-4`}>
              {order?.rider?.is_blacklisted ? 'Unblacklist Rider' : 'Blacklist Rider'}
            </button>
          )}
        </div>
      ) : (
        <NoRider order={order} isComplete={isComplete} />
      )}

      <ReassignRiderModal
        order={{ ...order, rider }}
        show={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={(newRider) => setRider(newRider)}
      />

      <BlacklistRiderModal
        show={showBlacklistRiderModal}
        onClose={() => setShowBlacklistRiderModal(false)}
        rider={order?.rider}
      />
    </div>
  );
};
export default OrderDetailsRider;
